import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-vpn.integration', {
        url: '/integration',
        component: 'integration',
        // resolve: {settings},
    });
}

/** @ngInject */
function settings(companyId,SaaspassVpnService) {
    return SaaspassVpnService.get(companyId);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-vpn/integration/integration.state.js